<template>
  <div class="exclusivePreferential-page flex">
    <el-form ref="form" class="my-form" :model="form" :rules="rules" label-width="120px" size="small">
      <div class="white-container">
        <el-form-item label="权益主标题" prop="titles">
          <div v-if="isEdit" class="mainTitleWrap flex">
            <template v-for="(mainTitle,titleN) in form.titles">
              <el-input :key="titleN+'mainTitle'" v-model="form.titles[titleN]" class="common-input" :placeholder="titleN === 0 ? '请输入第一行主标题文案' : '请输入第二行主标题文案' " />
            </template>
          </div>
          <div v-else class="lh-20" style="padding-top: 5px;">
            <div v-for="(mainTitle,titleN) in form.titles" :key="titleN+'mainTitle'">{{ mainTitle }}</div>
          </div>
        </el-form-item>
        <el-form-item label="副标题" prop="subtitles">
          <div v-if="isEdit" class="subTitleWrap flex">
            <template v-for="(subTitle,titleN) in form.subtitles">
              <el-input :key="titleN+'subTitle'" v-model="form.subtitles[titleN]" class="common-input" :placeholder="titleN === 0 ? '请输入第一行副标题文案' : '请输入第二行副标题文案'" />
            </template>
          </div>
          <div v-else class="lh-20" style="padding-top: 5px;">
            <div v-for="(subTitle,titleN) in form.subtitles" :key="titleN+'subTitle'">{{ subTitle }}</div>
          </div>
        </el-form-item>
        <el-form-item label="活动时间" prop="startTime" style="width: 279px">
          <el-date-picker v-model="form.startTime" type="datetime" placeholder="活动开始时间" prefix-icon="el-icon-date" class="custom-date" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss" :disabled="!isEdit" />
        </el-form-item>
        <el-form-item label="背景图" prop="imageUrl" class="image-config">
          <div class="flex uploadImg-cont">
            <UploadImage v-if="isEdit" :url="form.imageUrl" size-tips="960px*660px" :save-path="savePath" @upload="uploader" @triggerReg="handleCheckReg" />
            <img v-else class="read-img" :src="form.imageUrl" alt="">
          </div>
        </el-form-item>
        <el-form-item label="活动类型" prop="eventType">
          <template v-if="isEdit">
            <el-radio-group v-model="form.eventType">
              <el-radio :label="0">优惠券活动</el-radio>
              <el-radio :label="1">商品活动</el-radio>
            </el-radio-group>
          </template>
          <div v-else>{{ form.eventType === 0 ? '优惠券活动' : form.eventType === 1 ? '商品活动' : '' }}</div>

        </el-form-item>
        <el-form-item label="活动渠道" prop="activityType">
          <template v-if="isEdit">
            <el-radio-group v-model="form.activityType">
              <el-radio :label="1">线上</el-radio>
              <el-radio :label="2">线下</el-radio>
              <el-radio :label="3">线上+线下</el-radio>
            </el-radio-group>

          </template>
          <div v-else>{{ form.activityType === 1 ? '线上' : form.activityType === 2 ? '线下' :form.activityType === 3 ? '线上+线下' : '' }}</div>

        </el-form-item>
        <el-form-item v-if="form.eventType === 1" label="活动会员级别" prop="level">
          <template v-if="isEdit">
            <el-radio-group v-model="form.level">
              <el-radio :label="2">LV2级别以上</el-radio>
              <el-radio :label="4">LV4级别以上</el-radio>
            </el-radio-group>
          </template>
          <div v-else>{{ form.level === 2 ? 'LV2级别以上' : form.level === 4 ? 'LV4级别以上' : '' }}</div>
        </el-form-item>
        <el-form-item v-if="form.activityType === 1 || form.activityType === 3" label="线上购买链接" prop="linked">
          <template v-if="isEdit">
            <el-input v-model="form.linked" class="common-input w-360" placeholder="请输入EC购买链接地址" />
          </template>
          <div v-else>{{ form.linked }}</div>
        </el-form-item>
        <el-form-item v-if="form.eventType === 0" label="添加优惠券" prop="coupon">
          <template v-if="isEdit">
            <div class="add-conpon-title flex">
              <div class="level-box">会员等级</div>
              <div class="flex">
                <div class="label-box">非FP会员领取优惠券</div>
                <div class="label-box">FP会员领取优惠券</div>
              </div>
            </div>
            <div v-for="(item,index) in form.coupon" :key="'conpon'+index" class="conpon-wrap flex">
              <div class="level-box">
                {{ item.level === 2 ? 'Lv2及以上' : item.level === 4 ? 'Lv4及以上' : '其他' }}
              </div>
              <div class="content-wrap flex">
                <div class="content-box flex">
                  <div class="conpun-list">
                    <div v-for="(fp,fpI) in item.nonFpMember.couponIds" :key="fp+fpI" class="conpun-item">
                      <img src="@/assets/images/close.png" alt="" class="close" @click.stop="handleRemove({level:item.level, fpType:0,i:fpI})">
                      <div style="margin-left: 5px;">
                        ID:{{ fp }}
                      </div>
                    </div>
                  </div>
                  <div class="add-wrap" @click="handleAdd({level:item.level, fpType:0})">
                    <i class="el-icon-plus" />
                    <div>添加券</div>
                  </div>
                </div>
                <div class="content-box flex">
                  <div class="conpun-list">
                    <div v-for="(nonFp,nonI) in item.fpMember.couponIds" :key="nonFp+nonI" class="conpun-item">
                      <img src="@/assets/images/close.png" alt="" class="close" @click.stop="handleRemove({level:item.level, fpType:1,i:nonI})">
                      <div style="margin-left: 5px;">
                        ID:{{ nonFp }}
                      </div>
                    </div>
                  </div>
                  <div class="add-wrap" @click="handleAdd({level:item.level, fpType:1})">
                    <i class="el-icon-plus" />
                    <div>添加券</div>
                  </div>
                </div>
              </div>
            </div>

          </template>
          <div v-else>
            <div class="add-conpon-title flex">
              <div class="level-box">会员等级</div>
              <div class="flex">
                <div class="label-box">非FP会员领取优惠券</div>
                <div class="label-box">FP会员领取优惠券</div>
              </div>
            </div>
            <div v-for="(item,index) in form.coupon" :key="'conpon'+index" class="conpon-wrap flex">
              <div class="level-box">
                {{ item.level === 2 ? 'Lv2及以上' : item.level === 4 ? 'Lv4及以上' : '其他' }}
              </div>
              <div class="content-wrap flex">
                <div class="content-box flex">
                  <div class="conpun-list">
                    <div v-for="(fp,fpI) in item.nonFpMember.couponIds" :key="fp+fpI" class="conpun-item">
                      <div style="margin-left: 5px;">
                        ID:{{ fp }}
                      </div>
                    </div>
                  </div>
                  <div v-if="item.nonFpMember.couponIds&& item.nonFpMember.couponIds.length === 0" class="add-wrap" style="color: #bbb !important;">
                    <div>未配券</div>
                  </div>
                </div>
                <div class="content-box flex">
                  <div class="conpun-list">
                    <div v-for="(nonFp,nonI) in item.fpMember.couponIds" :key="nonFp+nonI" class="conpun-item">
                      <div style="margin-left: 5px;">
                        ID:{{ nonFp }}
                      </div>
                    </div>
                  </div>
                  <div v-if="item.fpMember.couponIds&& item.fpMember.couponIds.length === 0" class="add-wrap" style="color: #bbb !important;">
                    <div>未配券</div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </el-form-item>
        <el-form-item v-if="form.eventType === 1" class="opetare-box flex">
          <div class="flex btns">
            <template v-if="isEdit">
              <el-button type="info" @click="cancel">取消</el-button>
              <el-button type="primary" @click="submit">保存</el-button>
            </template>
            <el-button v-else type="primary" @click="cancel">返回</el-button>

          </div>
        </el-form-item>
      </div>
      <div v-if="form.eventType === 0" class="white-container mt-30">
        <div>
          <div>领券页面头图配置</div>
          <el-form-item label="图片" prop="headImage" class="image-config mt-30">
            <div class="flex uploadImg-cont">
              <UploadImage v-if="isEdit" :url="form.headImage" size-tips="1200px*600px" :save-path="savePath" @upload="headUp" @triggerReg="handleCheckHead" />
              <img v-else class="read-img" :src="form.headImage" alt="">
            </div>
          </el-form-item>
        </div>

        <el-form-item class="opetare-box flex">
          <div class="flex btns">
            <template v-if="isEdit">
              <el-button type="info" @click="cancel">取消</el-button>
              <el-button type="primary" @click="submit">保存</el-button>
            </template>
            <el-button v-else type="primary" @click="cancel">返回</el-button>

          </div>
        </el-form-item>
      </div>
      <el-dialog v-if="importDialogShow" :visible="importDialogShow" title="添加优惠券" custom-class="coupon-wrapper" @close="handleCloseImport">
        <div class="coupon-wrap">
          <div class="title">优惠券ID</div>
          <el-input v-model="couponStr" class="text" type="textarea" placeholder="请输入优惠券ID，可输入多个ID，多个ID用英文分号隔开" :rows="3" resize="none" />
        </div>
        <div class="flex btns">
          <el-button type="primary" @click="uploadSubmit">确认添加</el-button>
        </div>
      </el-dialog>

    </el-form>

  </div>
</template>

<script>
const propMap = {
  0: 'nonFpMember',
  1: 'fpMember',
};
import { ExclusivePreferential } from '@/model/Benefits';
import UploadImage from '@/components/UploadImage';
export default {
  components: { UploadImage },
  data() {
    return {
      form: new ExclusivePreferential(),
      rules: {
        titles: [
          {
            required: true, validator: (rule, value, callback) => {
              if (!Array.isArray(value)) {
                callback(new Error('请输入权益主标题'));
              }
              const bool = value.some(item => item !== '');
              if (!bool) {
                callback(new Error('请输入权益主标题'));
              }
              callback();
            }, trigger: ['blur', 'change'],
          },
        ],
        subtitles: [
          {
            required: true, validator: (rule, value, callback) => {
              if (!Array.isArray(value)) {
                callback(new Error('请输入副标题'));
              }
              const bool = value.some(item => item !== '');
              if (!bool) {
                callback(new Error('请输入副标题'));
              }
              callback();
            }, trigger: ['blur', 'change'],
          },
        ],
        startTime: { required: true, message: "请选择活动开始时间", trigger: ["blur", "change"] },
        imageUrl: {
          required: true, validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error(`请上传背景图`));
            }
            callback();
          }, trigger: ['change'],
        },
        eventType: { required: true, message: "请选择活动类型", trigger: ["blur", "change"] },
        activityType: { required: true, message: "请选择活动渠道", trigger: ["blur", "change"] },
        level: { required: true, message: "请选择活动会员级别", trigger: ["blur", "change"] },
        linked: { required: true, message: "请输入EC购买链接地址", trigger: ["blur", "change"] },
        coupon: { required: true, message: "请添加优惠券", trigger: ["blur", "change"] },
        headImage: {
          required: true, validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error(`请上传领券页面头图`));
            }
            callback();
          }, trigger: ['change'],
        },
      },
      isEdit: true,
      savePath: 'member/ExclusivePreferential/',
      importDialogShow: false,
      couponStr: '',
      fpType: undefined, // 0-NONFP,1-FP
      level: undefined,
    };
  },
  created() {
    const { query } = this.$route;
    if (query.id) {
      this.id = +query.id;
      this.fetchData();
    }
    if (query.readOnly) {
      this.isEdit = query.readOnly !== '1';
    }
  },
  methods: {
    fetchData() {
      const obj = {
        type: 4,
        exclusivePreferential: {},
        id: this.id,
      };
      this.$Api.benefits.query(obj).then(res => {
        if (res?.exclusivePreferential?.length) {
          const data = res.exclusivePreferential.find(item => item.id === this.id);
          if (!data) return;
          this.form = new ExclusivePreferential(data);
        }
      });
    },
    uploader(file) {
      this.form.imageUrl = file;
    },
    headUp(file) {
      this.form.headImage = file;
    },
    handleCheckReg() {
      this.$refs.form.validateField("imageUrl");
    },
    handleRemove(data) {
      const { level, fpType, i } = data;
      const prop = propMap[fpType];
      if (!prop) return;
      this.form.coupon.forEach(item => {
        if (item.level === level && item[prop]?.couponIds) {
          item[prop].couponIds.splice(i, 1);
        }
      });
    },
    handleAdd(data) {
      // type0-非FP会员,1-FP会员
      const { level, fpType } = data;
      if (fpType === 1 && this.form.activityType === 1) {
        return this.$message.warning("活动渠道选择线上，不可配置FP渠道的券码");
      }
      this.level = level;
      this.fpType = fpType;
      this.importDialogShow = true;
    },
    handleCheckHead() {
      this.$refs.form.validateField("headImage");
    },
    handleCloseImport() {
      this.importDialogShow = false;
      this.fpType = undefined;
      this.level = undefined;
      this.couponStr = '';
    },
    uploadSubmit() {
      if (!this.couponStr) {
        return this.$message.warning("请输入优惠券ID");
      }
      const prop = propMap[this.fpType];
      if (!prop) return;
      const list = this.couponStr.split(';').filter(item => item !== '');
      this.form.coupon.forEach(item => {
        if (item.level === this.level && item[prop]?.couponIds) {
          item[prop].couponIds = [...item[prop].couponIds, ...list];
        }
      });
      this.handleCloseImport();
    },
    cancel() {
      this.$router.push({ path: '/member/activityExclusivePreferential/index' });
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const str = this.form.id ? '编辑成功' : '新增成功';
          const api = this.form.id ? this.$Api.benefits.update : this.$Api.benefits.add;
          const obj = { type: 4, exclusivePreferential: this.form };
          api(obj).then(res => {
            this.$message.success(str);
            this.cancel();
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.exclusivePreferential-page {
  position: relative;

  min-height: calc(100vh - 178px);
  .mt-30 {
    margin-top: 30px;
  }
  .w-360 {
    width: 360px !important;
  }
  .lh-20 {
    line-height: 20px;
  }
  :deep(.custom-date) {
    width: 172px !important;
  }
  :deep(.el-input.is-disabled) {
    .el-input__icon {
      cursor: unset;
    }
    .el-input__inner {
      cursor: unset;

      color: #494949;
      border-color: #fff;
      background: #fff;
    }
  }
  :deep(.common-input) {
    width: 360px;
    height: 32px !important;
    margin-right: 30px;

    background: #f7f7f7;

    line-height: 32px !important;
    input {
      height: 32px !important;

      line-height: 32px !important;
    }
    :deep(.el-input__inner) {
      &::placeholder {
        color: #bbbbbb;
      }
    }
    &.underline {
      .el-input__inner {
        text-decoration: underline;
      }
    }
    .el-input__inner {
      color: #494949;
    }
  }
  .my-form {
    display: flex;
    flex: 1;
    flex-direction: column;
    .read-img {
      width: 210px;
      height: 150px;

      border: 1px dashed #e3e3e5;
      border-radius: 16px;
    }
    .add-conpon-title {
      color: #000;

      font-size: 14px;
      font-weight: 400;
      .level-box {
        width: 65px;
        height: 34px;
        margin-right: 10px;

        line-height: 34px;
      }
      .label-box {
        width: 338px;
        height: 34px;

        text-align: center;

        border-bottom: 1px solid #f8f8f9;
        background: #e3e3e5;
      }
    }
    .conpon-wrap {
      color: #000;

      font-size: 14px;
      font-weight: 400;
      & + .conpon-wrap {
        margin-top: 5px;
      }

      &:nth-of-type(2) .level-box {
        display: flex;
        align-items: center;

        height: 197px;
      }
      .level-box {
        width: 65px;
        height: 34px;
        margin-right: 10px;

        line-height: 34px;
      }
      .content-wrap {
        .content-box {
          flex-direction: column;

          width: 338px;
          height: 197px;

          border: 1px dashed #e3e3e5;
          background: #f7f7f7;
          .conpun-list {
            overflow-y: auto;

            max-height: 153px;
            .conpun-item {
              position: relative;

              height: 41px;
              margin: 10px 10px 0 10px;

              border-top: 4px solid #000;
              background: #fff;
              .close {
                position: absolute;
                top: -7px;
                right: -6px;

                display: block;

                width: 13px;
                height: 13px;

                cursor: pointer;
              }
            }
          }
          .add-wrap {
            display: flex;
            align-items: center;
            flex: 1;
            justify-content: center;

            cursor: pointer;

            color: #bbb;
            .el-icon-plus {
              margin-right: 6px;

              font-size: 12px;
            }
            &:hover {
              color: #000;
            }
          }
          &:first-of-type {
            border-radius: 4px 0px 0px 4px;
          }
          &:last-of-type {
            border-left: none;
            border-radius: 4px 0px 4px 0px;
          }
        }
      }
    }
  }
  .opetare-box {
    justify-content: center;

    margin-top: 30px;
    margin-bottom: 0 !important;
  }
  :deep(.el-dialog__wrapper) {
    display: flex;
    overflow: hidden;
    align-items: center;
    justify-content: center;
    .coupon-wrapper {
      width: 678px;
      margin: unset !important;
      .el-dialog__header {
        box-sizing: border-box !important;
        height: 74px !important;
        padding: 25px 30px !important;

        background: #000000 !important;

        .el-dialog__title {
          color: #ffffff;

          font-size: 16px;
          font-weight: 500;
        }
        .el-dialog__headerbtn {
          top: 25px;
          right: 30px;

          font-size: 24px;
          .el-dialog__close {
            color: #ffffff;
            &:hover {
              color: #dc0019;
            }
          }
        }
      }
      .el-dialog__body {
        padding: 30px;
        .coupon-wrap {
          display: flex;
          .title {
            margin-top: 7px;
            margin-right: 10px;

            white-space: nowrap;

            color: #494949;

            font-size: 14px;
            font-weight: 500;
            line-height: 20px;
          }
          .text {
            width: 618px;
          }
        }
      }
      .btns {
        justify-content: center;

        margin-top: 30px;
        .el-button {
          width: 120px;
          height: 50px;
        }
        .el-button + .el-button {
          margin-left: 30px;
        }
      }
    }
  }
}
</style>
